import { DeskData } from '@/datamodel/deskdata'
import { TableLimit } from '@/datamodel/types'
import { toMoneyFormat } from '@/utils'
import { MemberLimit, Table } from 'vue'
import { Options, Vue } from 'vue-class-component'
import { useI18n } from 'vue-i18n'
import { Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Options({})
export class HeaderMixin extends Vue {
    iN = useI18n().t
    @Prop({ default: true })
    isOnLoby = true
    @Prop({ default: '' }) title!: string

    @Prop({ default: false }) isMultiView!: boolean
    @Prop({ default: 0 }) goodRoadCount!: number
    //#region Vuex
    @Getter('betCoin') betCoin!: number
    @Getter('userId') userId!: string
    @Getter('currentDesk') currentDesk!: Table
    @Getter('deskLimit') deskLimit!: MemberLimit
    $emit!: Vue['$emit']
    $router!: Vue['$router']
    //#endregion

    //#region Helpers
    goToLoby(): void {
        this.$router.push({ name: 'loby' })
    }

    showSwitchTable(): void {
        this.$emit('show-switch-table')
        // console.log('showSwitchTable')
    }

    showSingleShow(): void {
        this.$emit('on-show-single-show')
    }

    openLink(): void {
        window.open('https://hq6868.info/', '_blank')
        // console.log('Link opened')
    }
    //#endregion

    // get coin(): string {
    //     return toMoneyFormat(this.betCoin)
    // }

    get min(): number {
        if (this.deskLimit) return this.deskLimit.downLimit || 0
        return 0
    }

    get max(): number {
        if (this.deskLimit) return this.deskLimit.upLimit || 0
        return 0
    }

    // get title(): string {
    //     if (this.isMultiView) return '自选多合一'

    //     const params = new URLSearchParams(window.location.search)
    //     const _gameType = params.get('gameType')

    //     if (_gameType) {
    //         if (_gameType === 'G002') {
    //             return `百家乐 ${this.currentDesk.tableNo} 号桌`
    //         } else if (_gameType === 'G003') {
    //             return `龙虎 ${this.currentDesk.tableNo} 号桌`
    //         }
    //     }
    // }
}
